import { useState, useEffect } from "react";
import Modal from "./news-letter-sub-modal.component";
import { useSelector } from "react-redux";
import { postImpexiumSubscriptionsUpdate } from "../../../redux/slice/impexium/impexium-subscriptions-update.slice";
import { RootState, useAppDispatch } from "../../../redux/store";

interface SubscriptionFields {
  name: string;
  value: string;
}

const HeaderUnSubscribeAllComponent = (props: { calledUnsubscribe: () => void }) => {
  const Preferences = useSelector((state: RootState) => state.preferences);
  const preferenceData = Preferences.data.result;

  const { data: userInfo } = useSelector((state: RootState) => state.impexiumUserInfo);

  const [showUnsubModal, setShowUnsubModal] = useState(false);
  const [defaultSubscriptionList, setDefaultSubscriptionList] = useState<SubscriptionFields[]>([]);

  const dispatch = useAppDispatch();
  const callUnsubcribe = () => {
    setShowUnsubModal(false);
    props.calledUnsubscribe();
    dispatch(postImpexiumSubscriptionsUpdate({ userId: userInfo.result.dataList[0].id, subscriptionField: defaultSubscriptionList }));
  };

  const handleUnsubModalEvent = () => {
    setShowUnsubModal(false);
    
  };

  const handleShowUnsubModalEvent = () => {
    setShowUnsubModal(true);
  };

  useEffect(() => {
    if (preferenceData?.length > 0) {
      let newSubscriptionList = [] as SubscriptionFields[];

      preferenceData.map((item) => {
        newSubscriptionList.push({ name: item.subName, value: item.subName.toLowerCase().includes("opt_out") ? "True" : "False" });
      });

      setDefaultSubscriptionList(newSubscriptionList);
    }
  }, [preferenceData]);


  return (
    <>
      <p>
        <a className="btn btn-danger unsub" style={{ marginRight: "2em" }} onClick={handleShowUnsubModalEvent}>
          Unsubscribe All
        </a>
      </p>
      {showUnsubModal && <Modal setShowModal={handleUnsubModalEvent} callUnsubscribe={callUnsubcribe} showUnsubscribe={true} />}
    </>
  );
};

export default HeaderUnSubscribeAllComponent;
